/**
 * Nombre de tronçons attendus par type de voyage.
 *
 * Cette règle vivait uniquement dans le formulaire (`flight-schemas.ts`), jamais dans le
 * contrat d'API : n'importe quel écrivain pouvait poser un ALLER-RETOUR à un seul tronçon,
 * et la demande devenait alors impossible à modifier — le formulaire refusait toute
 * soumission (« Un aller-retour doit avoir exactement 2 vols ») sans offrir d'ajout de
 * tronçon, réservé aux multi-destinations.
 */
export const FLIGHT_LEG_BOUNDS = {
    MULTI_DESTINATION: { max: 10, min: 2 },
    ONE_WAY: { max: 1, min: 1 },
    ROUND_TRIP: { max: 2, min: 2 },
};
/**
 * Message d'erreur du nombre de tronçons, ou `null` si le compte est bon.
 *
 * Source unique du formulaire (web et backoffice) et du contrat d'API : les deux doivent
 * accepter exactement les mêmes demandes, sinon l'API laisse entrer ce que le formulaire
 * ne saura plus rouvrir.
 */
export function checkFlightLegCount(type, count) {
    switch (type) {
        case 'MULTI_DESTINATION':
            if (count < FLIGHT_LEG_BOUNDS.MULTI_DESTINATION.min)
                return 'Au moins 2 vols requis';
            if (count > FLIGHT_LEG_BOUNDS.MULTI_DESTINATION.max)
                return 'Maximum 10 vols';
            return null;
        case 'ONE_WAY':
            return count === FLIGHT_LEG_BOUNDS.ONE_WAY.min
                ? null
                : 'Un aller simple doit avoir exactement 1 vol';
        case 'ROUND_TRIP':
            return count === FLIGHT_LEG_BOUNDS.ROUND_TRIP.min
                ? null
                : 'Un aller-retour doit avoir exactement 2 vols';
        default:
            return null;
    }
}
